import { Flex, Tabs, TabList, Tab } from '@chakra-ui/react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

function HomeLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeIndex = location.pathname === '/studio' ? 1 : 0;

  return (
    <Flex direction="column" flex="1" bgColor="#646AB0">
      <Flex justifyContent="center" pt={4}>
        <Tabs
          index={activeIndex}
          onChange={(i) => navigate(i === 0 ? '/' : '/studio')}
          isFitted
          width="100%"
          maxW="sm"
        >
          <TabList borderColor="whiteAlpha.400">
            <Tab
              color="whiteAlpha.700"
              fontWeight="medium"
              _selected={{ color: "white", borderBottomColor: "white", fontWeight: "bold" }}
            >
              DodoDot Official
            </Tab>
            <Tab
              color="whiteAlpha.700"
              fontWeight="medium"
              _selected={{ color: "white", borderBottomColor: "white", fontWeight: "bold" }}
            >
              DodoDot Studio
            </Tab>
          </TabList>
        </Tabs>
      </Flex>
      <Outlet />
    </Flex>
  );
}

export default HomeLayout;
